/* eslint-disable no-console */
import { Typography } from "@mui/material";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import type { FileWithPath } from "react-dropzone";

import { formatFileSize, getIcon, steps } from "./helper";
import { FileExtractionStatus } from "../../models/jobStatus";
import ErrorDialog from "../errorDialog";
import ErrorIcon from "@mui/icons-material/Error";

const AcceptedFile = (props: any) => {
  const fileProp: { file: FileWithPath & { status: FileExtractionStatus } } =
    props;
  const { isRemoveEnabled, handleRemoveFile, errorId } = props;

  const didFail = (): boolean => {
    return fileProp.file.status > FileExtractionStatus.ExtractionCompleted;
  };

  return (
    <div
      key={fileProp.file.name}
      className="flex items-center justify-between gap-x-6 py-1"
    >
      <div className="flex min-w-0 gap-x-4">
        <img
          height={48}
          width={48}
          className="size-12 flex-none rounded-md"
          src={getIcon(fileProp.file.type)}
          alt="file icon"
        />
        <div className="min-w-0 flex-auto">
          <p className="truncate text-sm font-semibold leading-6 text-gray-900">
            {fileProp.file.name}
          </p>
          <p className="mt-1 truncate text-xs leading-5 text-gray-500">
            {formatFileSize(fileProp.file.size)}
          </p>
        </div>
      </div>
      <div className="">
        <div
          className={`mx-auto flex max-w-sm cursor-pointer items-center rounded-lg bg-red-500 p-2 text-white hover:bg-red-600 ${
            isRemoveEnabled ? "" : "hidden"
          }`}
          onClick={() => handleRemoveFile(fileProp.file.name)}
        >
          <button className="mx-auto">{String.fromCharCode(0x2715)}</button>
        </div>
        <div
          className={`mx-auto flex max-w-sm cursor-pointer items-center p-2${
            isRemoveEnabled ? "hidden" : ""
          }`}
        >
          {!isRemoveEnabled && (
            <>
              {!didFail() ? (
                <Stepper
                  activeStep={
                    fileProp.file.status ? fileProp.file.status + 1 : 0
                  }
                  alternativeLabel
                >
                  {steps.map((step) => {
                    const stepProps: { completed?: boolean } = {};
                    const labelProps: {
                      optional?: React.ReactNode;
                      error?: boolean;
                    } = {};

                    if (
                      fileProp.file.status >
                      FileExtractionStatus.ExtractionCompleted
                    ) {
                      labelProps.optional = (
                        <Typography
                          variant="caption"
                          color="error"
                        ></Typography>
                      );
                      labelProps.error = true;
                    }

                    return (
                      <Step key={step} {...stepProps}>
                        <StepLabel {...labelProps}></StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              ) : (
                <div className="flex items-center">
                  <ErrorIcon className="text-red-600" />
                  <ErrorDialog id={errorId} />
                </div>
              )}
            </>
          )}
          {!isRemoveEnabled && (
            <span
              className={`font-medium ${
                fileProp.file.status > FileExtractionStatus.ExtractionCompleted
                  ? "text-red-600"
                  : "text-green-600"
              }`}
            >
              {/* {fileProp.file.status} */}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AcceptedFile;
